import { render, staticRenderFns } from "./conference.vue?vue&type=template&id=13890ca0&scoped=true&"
import script from "./conference.vue?vue&type=script&lang=js&"
export * from "./conference.vue?vue&type=script&lang=js&"
import style0 from "./conference.vue?vue&type=style&index=0&id=13890ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13890ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13890ca0')) {
      api.createRecord('13890ca0', component.options)
    } else {
      api.reload('13890ca0', component.options)
    }
    module.hot.accept("./conference.vue?vue&type=template&id=13890ca0&scoped=true&", function () {
      api.rerender('13890ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/conference/conference.vue"
export default component.exports